import React from 'react';
import { Spin } from 'antd';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Dialog from '../../../core/layout/Dialog';
import TooltipIcon from '../../../core/layout/TooltipIcon';
import Button from '../../../core/form/Button';
import ImportCsvDialogUploadScene from './ImportCsvDialogUploadScene';
import ImportCsvDialogPreviewScene from './ImportCsvDialogPreviewScene';
import ImportCsvDialogResultScene from './ImportCsvDialogResultScene';

const ImportCsvDialog = (props) => (
  <Dialog
    title={
      <React.Fragment>
        <span>Import csv</span>
        <TooltipIcon text="Use export file option to get a template. The fourth column of csv file will be used to set the values for selected locale by you." />
      </React.Fragment>
    }
    isOpen={props.isOpen}
    onCancel={props.onClose}
    width={800}
    actions={
      (props.currentScene === 'UPLOAD' && []) ||
      (props.currentScene === 'PREVIEW' && [
        <Button label="Discard file" icon="undo" onClick={props.onDiscardPreview} disabled={props.submitting} />,
        <Button
          label="Confirm"
          type="primary"
          icon="check"
          onClick={() => props.setScene('IMPORT')}
          disabled={(get(props.values, 'locale') ? false : true) || props.submitting}
          onChange={props.onChange}
          onUpload={props.onUpload}
        />,
      ]) ||
      (props.currentScene === 'IMPORT' && [
        <Button label="No" onClick={() => props.setScene('PREVIEW')} disabled={props.submitting} />,
        <Button label="Yes" type="primary" onClick={props.onImport} disabled={props.submitting} />,
      ]) ||
      (props.currentScene === 'RESULT' && [
        <Button label="OK" type="primary" onClick={props.onClose} disabled={props.submitting} />,
      ])
    }
  >
    {props.submitting ? (
      <div
        style={{
          flex: 1,
          display: 'flex',
          height: '300px',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Spin size="large" />
        <span style={{ marginTop: '30px' }}>Processing...</span>
      </div>
    ) : (
      <React.Fragment>
        {props.currentScene === 'UPLOAD' && (
          <ImportCsvDialogUploadScene onChange={props.onChange} onUpload={props.onUpload} />
        )}
        {['PREVIEW', 'IMPORT'].some((scene) => scene === props.currentScene) && (
          <ImportCsvDialogPreviewScene
            currentScene={props.currentScene}
            values={props.values}
            onChange={props.onChange}
            errors={props.errors}
          />
        )}
        {props.currentScene === 'RESULT' && (
          <ImportCsvDialogResultScene
            values={props.values}
            errors={get(props.values, 'importResult.errors', [])}
            totalRows={get(props.values, 'importResult.totalRows', 0)}
          />
        )}
      </React.Fragment>
    )}
  </Dialog>
);

ImportCsvDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onUpload: PropTypes.func,
  onImport: PropTypes.func,
  isOpen: PropTypes.bool,
  currentScene: PropTypes.oneOf(['UPLOAD', 'PREVIEW', 'IMPORT', 'RESULT']),
  values: PropTypes.object,
  errors: PropTypes.object,
  onDiscardPreview: PropTypes.func,
  submitting: PropTypes.bool,
};

ImportCsvDialog.defaultProps = {
  isOpen: false,
  currentScene: 'UPLOAD',
  values: {},
  errors: null,
  submitting: false,
};

export default ImportCsvDialog;
